import React, { useEffect, useState, useCallback } from "react";
import { Row, Col, Container, Button } from "react-bootstrap";
import apiCall from "../../API/API";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchCappingUser } from "../../Actions/adminActions";
import PaginationComponent from "../../Component/Pagination/PaginationControls";
import moment from "moment";
import { BiFilter } from "react-icons/bi";
import { GrPowerReset } from "react-icons/gr";
import debounce from "lodash.debounce";

const AddCapping = () => {
  const [username, setUsername] = useState("");
  const [capping, setCapping] = useState("");

  const [existUsername, setExistUsername] = useState();

  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("authToken");
  const [typingTimeout, setTypingTimeout] = useState(null);

  //filter
  const [data, setData] = useState([]);
  const { cappinguser } = useSelector((state) => state.admin);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filter, setFilter] = useState("none");
  const [search, setSearch] = useState({
    username: "",
    search: "", 
    startDate: "",
    endDate: ""
  });

  const [limitFilter, setLimitFilter] = useState(20);
  const [dateFilter, setDateFilter] = useState("default");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!username|| !capping) {
      toast.error("Please fill in all fields");
      setLoading(false);
      return;
    }

    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: token,
        },
      };
      const body ={
        "username": username,
        "capping" : capping
      }
      console.log("post body", body);
      const { data, error } = await apiCall(
        "POST",
        "/add_capping",
        {username, capping},
        config
      );

      if (data) {
        setUsername("");
        setCapping("");
        fetchCapping();
      } else if (error) {
        // toast.error(error.message || "An error occurred");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
    }
    setLoading(false);
  };

  const isUserExist = async () => {
    setLoading(true);

    if (!username) {
      setExistUsername(". . .");
      setLoading(false);
      return;
    }

    try {
      const { data, error } = await apiCall("post", "/check_username", {
        username: username,
      });
      if (data) {
        setExistUsername(data?.name);
      } else if (error) {
        setExistUsername("User not exists");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
    }
    setLoading(false);
  };

  useEffect(() => {
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    setTypingTimeout(
      setTimeout(() => {
        isUserExist();
      }, 1000)
    );

    return () => clearTimeout(typingTimeout);
  }, [username]);

  //filter
  const fetchCapping = useCallback(
    debounce((params) => {
      dispatch(fetchCappingUser(params));
    }, 500),
    [dispatch]
  );

  const toggleFilter = () => {
    if (filter === "none") {
      setFilter("flex");
    } else {
      setFilter("none");
    }
  };

  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "startDate") {
      setStartDate(value);
    } else if (name === "endDate") {
      setEndDate(value);
    } else {
      setSearch((prev) => {
        const updatedSearch = { ...prev, [name]: value };
        Object.keys(updatedSearch).forEach((key) => {
          if (updatedSearch[key] === "" || updatedSearch[key] === 0) {
            delete updatedSearch[key];
          }
        });
        return updatedSearch;
      });
    }
    fetchCapping({
      page: currentPage,
      limit: limitFilter,
      ...Object.fromEntries(
        Object.entries(search).filter(
          ([_, value]) => value !== "" && value !== 0
        )
      ),
      ...(startDate && endDate ? { startDate, endDate } : {}),
    });
  };

  const handleLimitChange = (e) => {
    setLimitFilter(e.target.value);
  };

  const handleDateFilterChange = (e) => {
    const value = e.target.value;
    setDateFilter(value);
    const today = moment().endOf("day");
    let start = "";
    let end = "";
    switch (value) {
      case "today":
        start = today.startOf("day").format("YYYY-MM-DD");
        end = today.format("YYYY-MM-DD");
        break;
      case "yesterday":
        start = today.subtract(1, "days").startOf("day").format("YYYY-MM-DD");
        end = today.endOf("day").format("YYYY-MM-DD");
        break;
      case "this_week":
        start = today.startOf("week").format("YYYY-MM-DD");
        end = today.endOf("week").format("YYYY-MM-DD");
        break;
      case "this_month":
        start = today.startOf("month").format("YYYY-MM-DD");
        end = today.endOf("month").format("YYYY-MM-DD");
        break;
      default:
        start = "";
        end = "";
        break;
    }
    setStartDate(start);
    setEndDate(end);
  };

  const addFilter = () => {
    const queryParams = {
      page: currentPage,
      limit: limitFilter,
      ...Object.fromEntries(
        Object.entries(search).filter(
          ([_, value]) => value !== "" && value !== 0
        )
      ),
    };

    if (startDate) {
      queryParams.startDate = startDate;
    }
    if (endDate) {
      queryParams.endDate = endDate;
    }
    // console.log(queryParams);
    dispatch(fetchCappingUser(queryParams));
  };

  const resetFilter = () => {
    setSearch({
      username: "",
      search: "",
      startDate: "",
      endDate: "",
    });
    setLimitFilter(20);
    setStartDate("");
    setEndDate("");
    setDateFilter("default");
    setCurrentPage(1);

    dispatch(
      fetchCappingUser({
        page: 1,
        limit: 20,
      })
    );
  };

  useEffect(() => {
    const queryParams = {
      page: currentPage,
      limit: limitFilter,
      ...Object.fromEntries(
        Object.entries(search).filter(
          ([_, value]) => value !== "" && value !== 0
        )
      ),
    };
    if (startDate && endDate) {
      queryParams.startDate = startDate;
      queryParams.endDate = endDate;
    }
    fetchCapping(queryParams);
  }, [
    dispatch,
    currentPage,
    limitFilter,
    search,
    startDate,
    endDate,
    fetchCapping,
  ]);

  useEffect(() => {
    setTotalPages(cappinguser?.pagination?.totalPages);
  }, [cappinguser]);

  return (
    <React.Fragment>
      <Container className="mt-4">
        <section id="add-funds-section">
          <div className="d-flex justify-content-center">
            <h2>Add Capping</h2>
          </div>
          <section id="formContent">
            <div className="form">
              <Row>
                <Col lg={6} style={{ margin: "auto" }}>
                  <form onSubmit={handleSubmit}>
                    <div id="formFields">
                        <div className="mb-3">
                        <div className="d-flex">
                          <label htmlFor="username">User Name:</label>
                          <label
                            style={{ textAlign: "end" }}
                            htmlFor="username"
                          >
                            {loading && username ? "Loading..." : existUsername}
                          </label>
                        </div>
                        <input
                          type="text"
                          id="username"
                          className="form-control"
                          value={username}
                          onChange={(e) => setUsername(e.target.value)}
                          placeholder="Enter Username"
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="amount">Capping:</label>
                        <input
                          type="number"
                          id="amount"
                          className="form-control"
                          value={capping}
                          onChange={(e) => setCapping(e.target.value)}
                          placeholder="Enter Capping"
                        />
                      </div>
                      <Button type="submit" variant="primary" disabled={loading}>
                        {loading ? "Submitting..." : "Submit"}
                      </Button>
                      <Button
                        variant="secondary"
                        className="ms-2"
                        onClick={() => {
                          setUsername("");
                          setCapping("");
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                  </form>
                </Col>
              </Row>
            </div>
          </section>
        </section>
         {/* <ToastContainer className="toast-container" /> */}
      </Container>
      
      {/* table */}
      <Container>
        <Row id="filterRow">
          <span id="filterLogo1" onClick={toggleFilter}>
            <i>
              <BiFilter />
            </i>
            Filter
          </span>

          <Row className="p-0 m-0" style={{ display: filter }}>
            <Col lg="2" md="4">
              <div>
                <input
                  type="text"
                  name="username"
                  placeholder="Search for Username"
                  value={search.username}
                  onChange={handleChange}
                />
              </div>
            </Col>
            {/* <Col lg="2" md="4">
              <div>
                <input
                  type="text"
                  name="username"
                  placeholder="to Username"
                  value={search.username}
                  onChange={handleChange}
                />
              </div>
            </Col> */}
            <Col lg="2" md="4">
              <div>
                <input
                  type="date"
                  name="startDate"
                  placeholder="Start Date"
                  value={startDate}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="date"
                  name="endDate"
                  placeholder="End Date"
                  value={endDate}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <select
                  name="dateFilter"
                  value={dateFilter}
                  onChange={handleDateFilterChange}
                >
                  <option value="default">Default</option>
                  <option value="today">Today</option>
                  <option value="yesterday">Yesterday</option>
                  <option value="this_week">This Week</option>
                  <option value="this_month">This Month</option>
                </select>
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <select value={limitFilter} onChange={handleLimitChange}>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                </select>
              </div>
            </Col>
            <div>
              <button className="save filter" onClick={addFilter}>
                Filter{" "}
                <i>
                  <BiFilter />
                </i>
              </button>
              <button className="cancel reset" onClick={resetFilter}>
                Reset{" "}
                <i>
                  <GrPowerReset />
                </i>
              </button>
            </div>
          </Row>
        </Row>
        <div id="directIncomeDiv">
          <Row id="directTableRow" className="text-center">
            <Col md="12" className="p-0">
              <div style={{ width: "100%" }}>
                <table>
                  <tr>
                    <th>S No.</th>
                    <th>Username</th>
                    <th>Capping</th>
                    <th>Date & Time</th>
                  </tr>
                  {cappinguser?.data?.map((x, i) => (
                    <tr key={x._id}>
                      <td>{i + 1 + limitFilter * (currentPage - 1)}</td>
                      <td>{x.username}</td>
                      <td>{x?.capping_set_admin}</td>
                      <td>
                        {moment(x?.capping_set_Date).format("MM-DD-YYYY   &   HH:mm")}
                      </td>
                    </tr>
                  ))}
                </table>
              </div>
            </Col>
          </Row>
        </div>
        <Row>
          <Col md="12">
            {
              <PaginationComponent
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePagination}
              />
            }
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default AddCapping;
